
<template>
  <section id="hero" class="hero"
    @mousemove="mousemove">
    <div class="scene scene--parallax">
      <div
        class="scene__item scene__item--bg"
        data-depth="-5"
        :style="backimg"
        ref="bg"
      ></div>
    </div>

    <div class="wrapper">
      <div class="row">
        <div class="col-7 col-tabletW-11 offset-1 offset-tabletW-0">
          <h1 class="title anim--split ft-40" data-split="chars">
            {{ title }}
          </h1>
        </div>
      </div>
      <div class="row">
        <div class="col-6 col-tabletW-11 offset-1 offset-tabletW-0">
          <p class="lines text--medium color--bluelight anim--split ff-dr ft-25" data-split="lines">{{ sub }}</p>
        </div>
      </div>
    </div>

    <SeaDive ref="dive" />
  </section>
</template>

<script>
import SeaDive from './SeaDive.vue'

export default {
  components: {
    SeaDive
  },

  props: {
    backimg: String,
    title: String,
    sub: String
  },

  mounted () {
    setTimeout(() => {
      this.$refs.dive.start()
    }, 1000)

    this.ratio = {
      x: 0,
      y: 0
    }

    this.depth = -5
  },

  methods: {
    mousemove () {
      this.ratio.x += 0.05 * (window.mouse.x / window.w * 2 - 1 - this.ratio.x)
      this.ratio.y += 0.05 * (window.mouse.y / window.h * 2 - 1 - this.ratio.y)
      this.update()
    },

    update () {
      const x = (50 * this.ratio.x / this.depth).toFixed(2)
      const y = (50 * this.ratio.y / this.depth).toFixed(2)

      this.render(x, y)
    },

    render (x, y) {
      this.$refs.bg.style.transform =
        this.$refs.bg.style.webkitTransform =
          `translateX(${x}px) translateY(${y}px) rotateZ(0.01deg)`
    }
  }
}
</script>

<style lang="scss" scoped>
.hero {
  width: 100%;
  height: 100vh;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -ms-flex-align: center;
  align-items: center;
  color: #fff;
}

.title {
  line-height: 80px;
}

.lines {
  line-height: 50px;
  max-width: 660px;
}

.hero .title,
.hero .title--small,
.hero .title--smallest,
.hero h2,
.hero h3,
.hero h4,
.hero h5 {
  max-width: 685px;
}
@media (max-width: 1366px){
  .title{
    line-height: 55px;
  }
}
@media (min-width: 1441px) {
  .hero .title,
  .hero .title--small,
  .hero .title--smallest,
  .hero h2,
  .hero h3,
  .hero h4,
  .hero h5 {
    max-width: none;
  }
}

.hero .title--big {
  max-width: none;
}

.hero p {
  margin: 0;
}

.hero:not(.hero--expedition) {
  height: calc(100vh + 150px);
}

@media (max-width: 979px) {
  .hero:not(.hero--expedition) {
    height: calc(100vh + 100px);
  }
}

.hero:not(.hero--expedition) .scene {
  top: -25px;
  left: -25px;
  width: calc(100% + 50px);
  height: calc(100% + 50px);
  overflow: hidden;
}

.hero:not(.hero--expedition) .scene:after {
  content: "";
  width: 100%;
  height: 410px;
  left: 0;
  bottom: -1px;
  background: url(/images/hero-radial-gradiant.png) no-repeat center bottom;
  background-size: 100% auto;
}

@media (min-width: 1921px) {
  .hero:not(.hero--expedition) .scene:after {
    background-position: center top;
  }
}

@media (max-width: 480px) {
  .hero:not(.hero--expedition) .wrapper {
    margin-top: -75px;
  }
}

.hero:not(.hero--expedition) + .section {
  margin-top: -80px;
}

@media (max-width: 1280px) {
  .hero:not(.hero--expedition) + .section {
    margin-top: -50px;
  }
}

.hero--expedition {
  overflow: hidden;
}

.hero--expedition canvas {
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  position: absolute;
}

.hero--expedition .scene {
  transform-origin: center;
}

@media (min-width: 1025px) {
  .hero--expedition .scene {
    top: -25px;
    left: -25px;
    width: calc(100vw + 50px);
    height: calc(100vh + 50px);
  }
}

@media (max-width: 1024px) {
  .hero--expedition .scene {
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh !important;
  }
}

.hero--expedition .scene:after {
  content: "";
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  background: radial-gradient(ellipse at center, transparent 0, #041324 70%);
  background-size: 100% 100%;
}

@media (max-width: 1024px) {
  .hero--expedition .scene:after {
    background: url(/images/hero-expedition-radial-gradiant.png) no-repeat
      center;
    background-size: 100% 100%;
  }
}

.hero--expedition .scene__item {
  background-position: center;
}

.page--404 .hero--expedition .scene__item {
  opacity: 0.5;
}

.page--404 .hero--expedition .scene {
  background-color: #0b1539;
}

.hero--expedition .title,
.hero--expedition .title--small,
.hero--expedition .title--smallest,
.hero--expedition h2,
.hero--expedition h3,
.hero--expedition h4,
.hero--expedition h5 {
  margin: 0;
}

@media (max-width: 768px) {
  .hero--expedition .title,
  .hero--expedition .title--small,
  .hero--expedition .title--smallest,
  .hero--expedition h2,
  .hero--expedition h3,
  .hero--expedition h4,
  .hero--expedition h5 {
    font-size: 9.5vw;
  }
}

@media (max-width: 480px) {
  .hero--expedition .title,
  .hero--expedition .title--small,
  .hero--expedition .title--smallest,
  .hero--expedition h2,
  .hero--expedition h3,
  .hero--expedition h4,
  .hero--expedition h5 {
    font-size: 8.5vw;
  }
}

.hero--expedition .button {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -90px;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -ms-flex-pack: center;
  justify-content: center;
  margin: 0;
}

@media (max-width: 768px) {
  .hero--expedition .button {
    left: 0;
    right: 0;
    transform: none;
  }
}

.hero--expedition .dive {
  top: calc(50% + 100vw / 5.4 - 12px);
  transform: translateY(-50%);
}

@media (max-width: 1024px) {
  .hero--expedition .dive {
    top: 100vh;
    transform: translateY(-100%);
  }
}

.hero--expedition__navigation {
  transition: all 0.4s;
}

.hero--expedition__navigation--hidden {
  visibility: hidden;
  opacity: 0;
}

.hero--expedition__navigation a {
  position: absolute;
  top: calc(50vh - 5px);
  color: #fff;
  z-index: 1001;
}

.hero--expedition__navigation a i.icon-arrow-left,
.hero--expedition__navigation a i.icon-arrow-right {
  font-size: 2.3rem;
}

@media (max-width: 768px) {
  .hero--expedition__navigation a i.icon-arrow-left,
  .hero--expedition__navigation a i.icon-arrow-right {
    font-size: 1.7rem;
  }
}

.hero--expedition__navigation__left {
  left: 80px;
}

@media (max-width: 1024px) {
  .hero--expedition__navigation__left {
    left: 45px;
  }
}

@media (max-width: 768px) {
  .hero--expedition__navigation__left {
    left: 15px;
  }
}

.hero--expedition__navigation__right {
  right: 80px;
}

@media (max-width: 1024px) {
  .hero--expedition__navigation__right {
    right: 45px;
  }
}

@media (max-width: 768px) {
  .hero--expedition__navigation__right {
    right: 15px;
  }
}

.hero--expedition__fill {
  position: absolute;
  background: #cae6f9;
  z-index: 900;
}

.hero--expedition__fill--left,
.hero--expedition__fill--right {
  height: 100vh;
  top: 0;
  width: calc((100vw - 1280px + 36px) * 0.5 + 10px);
}

@media (min-width: 1441px) {
  .hero--expedition__fill--left,
  .hero--expedition__fill--right {
    width: calc((100vw - 1360px + 36px) * 0.5 + 10px);
  }
}

@media (min-width: 1681px) {
  .hero--expedition__fill--left,
  .hero--expedition__fill--right {
    width: calc((100vw - 1600px + 36px) * 0.5 + 10px);
  }
}

@media (min-width: 1921px) {
  .hero--expedition__fill--left,
  .hero--expedition__fill--right {
    width: calc((100vw - 1840px + 36px) * 0.5 + 10px);
  }
}

@media (max-width: 1280px) {
  .hero--expedition__fill--left,
  .hero--expedition__fill--right {
    width: 28px;
  }
}

.hero--expedition__fill--left {
  left: -10px;
  transform-origin: left;
}

.hero--expedition__fill--right {
  right: -10px;
  transform-origin: right;
}

.hero--expedition__fill--bottom,
.hero--expedition__fill--top {
  width: 100%;
  height: calc((100vh - 548px) / 2 + 10px);
  left: 0;
}

@media (min-width: 1441px) {
  .hero--expedition__fill--bottom,
  .hero--expedition__fill--top {
    height: calc((100vh - 680px) / 2 + 10px);
  }
}

@media (min-width: 1681px) {
  .hero--expedition__fill--bottom,
  .hero--expedition__fill--top {
    height: calc((100vh - 740px) / 2 + 10px);
  }
}

@media (max-width: 1024px) {
  .hero--expedition__fill--bottom,
  .hero--expedition__fill--top {
    height: calc((100vh - 520px) / 2 + 10px);
  }
}

.hero--expedition__fill--top {
  transform-origin: top;
  top: -10px;
}

.hero--expedition__fill--bottom {
  transform-origin: bottom;
  bottom: -10px;
}
@media(max-width: 768px){
  .hero .title{
    font-size: 30px;
  }
}
</style>
